const ta = {
  // COMMON
  language: "மொழி",
  note: "குறிப்பு:",
  date: "தேதி",
  time: "நேரம்",
  price: "விலை",
  month: "மாதம்",
  nearbyTemples: "அருகிலுள்ள கோவில்கள்",
  createTemples: "கோவில்களை உருவாக்கு",
  temples: "கோவில்கள்",
  latestTemples: "சமீபத்திய கோவில்கள்",
  groupOfTemples: "கோவில்களின் குழு",

  //DASHBOARD
  templeCreateDescription:
    "ஒரு கோவில் சுயவிவரம் உருவாக்குவது எளிமையானது, அர்த்தமுள்ளதாகவும் இலவசமாகவும் உள்ளது. உங்கள் கோவிலின் கதை பிறருக்கு الهர்ச்சி அளித்து, வளர்ந்து வரும் ஆன்மீக வலையமைப்பின் ஓரங்கமாகுங்கள்.",

  // NAVIGATION
  backToSearch: "தேடலுக்கு திரும்பு",
  backToDashboard: "டாஷ்போர்டுக்கு திரும்பு",
  templeView: "கோவில் பார்வை",
  editTemples: "கோவில்களை திருத்து",
  backToTemples: "கோவில்களுக்கு திரும்பு",

  // PROFILE
  profile: "சுயவிவரம்",
  personalInfo: "தனிப்பட்ட தகவல்",
  locationBackground: "இடம் & பின்னணி",
  spiritualIdentification: "ஆன்மீகம் & அடையாளம்",
  editProfile: "சுயவிவரத்தைத் திருத்தவும்",
  profilePhoto: "சுயவிவர புகைப்படம்",
  backToProfile: "சுயவிவரத்திற்கு திரும்பு",
  saveProfile: "சுயவிவரத்தை சேமிக்கவும்",
  optional: "(விருப்பத்தேர்வு)",

  // TEMPLE DETAILS
  templeGallery: "கோவில் தொகுப்பு",
  mainDeity: "மூலத் தெய்வம்",
  otherDeity: "பிற தெய்வங்கள்",

  // ADDRESS
  location: "இடம்",
  address: "முகவரி",
  city: "நகரம்",
  district: "மாவட்டம்",
  state: "மாநிலம்",
  pincode: "அஞ்சல் குறியீடு",
  geographicCoordinates: "புவியியல் இணை",
  cityTownVillage: "நகரம் / பேரூராட்சி / கிராமம்",

  // FACILITIES
  availableFacilities: "கிடைக்கும் வசதிகள் & அணுகல்",
  ritualsGuidelines: "பொது தகவல்",
  dressCode: "உடை விதிமுறை",
  festivalEvents: "திருவிழாக்கள் & நிகழ்வுகள்",
  poojaDetails: "பூஜை விவரங்கள்",
  contactInfo: "தொடர்பு தகவல்",
  templeTimings: "கோவில் நேரங்கள்",
  morning: "காலை",
  afternoon: "மதியம்",
  sthalaVirutcham: "ஸ்தல விருட்சம்",
  bestTime: "வர சிறந்த நேரம்",
  atonementRituals: "இந்த கோவிலில் பிராயச்சித்த சடங்குகள்",
  howToReach: "எப்படி செல்வது",
  km: "கி.மீ",

  // OWNERSHIP
  ownershipDetails: "கோவில் உரிமை விவரங்கள்",
  managedBy: "நிர்வகிப்பவர்",

  //TEMPLE CONTACT
  templeEmail: "கோவில் மின்னஞ்சல் முகவரி",
  templeOwnershipContact: "கோவில் உரிமையாளர் தொடர்பு தகவல்",
  otherContactInfo: "பிற தொடர்பு தகவல்",

  // REVIEWS
  reviews: "விமர்சனங்கள்",
  communityReviews: "எங்கள் சமூகத்தின் விமர்சனங்கள்",
  searchReviews: "விமர்சனங்களை தேடு",
  reviewDetails: "விமர்சன விவரங்கள்",
  review: "விமர்சனம்",

  // EXPERIENCES
  userExperience: "அனுபவங்கள்",
  shareYourExperience: "உங்கள் அனுபவத்தை பகிருங்கள்",
  communityExperiences: "எங்கள் சமூகத்தின் அனுபவங்கள்",
  searchExperiences: "அனுபவங்களைத் தேடுங்கள்",
  experienceDetails: "அனுபவ விவரங்கள்",
  search: "தேடல்",

  // SUGGESTIONS
  suggestUpdate: "புதுப்பிப்பை பரிந்துரைக்கவும்",
  helpImprove1: "நாங்கள் தவறவிட்டதை நீங்கள் அறிந்திருக்கிறீர்களா",
  helpImprove2:
    "தகவல் துல்லியமாகவும் புதுப்பிக்கப்பட்டதாகவும் இருக்க உங்கள் பரிந்துரைகளை பகிரவும்.",
  suggestion: "பரிந்துரை",

  // LINKS
  referenceLink: "குறிப்பு இணைப்பு",
  otherGroupTemples: "இந்தக் குழுவில் உள்ள பிற கோவில்கள்",

  // BUTTON LABELS
  viewAllTemples: "அனைத்து கோவில்களையும் காண்க",
  getDirection: "வழிகாட்டியைப் பெற",
  website: "கோவில் இணையதளம்",
  writeReview: "ஒரு விமர்சனம் எழுதுக",
  addSuggestion: "பரிந்துரையைச் சேர்க்கவும்",
  next: "அடுத்தது",
  previous: "முந்தையது",
  cancel: "ரத்து செய்",
  submit: "சமர்ப்பிக்கவும்",
  updatePassword: "கடவுச்சொல்லை புதுப்பிக்கவும்",
  updateNow: "இப்போது புதுப்பிக்கவும்",

  // INPUT LABELS
  name: "பெயர்",
  phoneNumber: "தொலைபேசி எண்",

  // PASSWORD
  currentPassword: "தற்போதைய கடவுச்சொல்",
  newPassword: "புதிய கடவுச்சொல்",
  confirmNewPassword: "புதிய கடவுச்சொல்லை உறுதிப்படுத்தவும்",
  passwordNote:
    "உங்கள் கடவுச்சொல்லை வெற்றிகரமாகப் புதுப்பித்த பிறகு, பாதுகாப்பு காரணங்களுக்காக நீங்கள் தானாகவே உள்நுழைவு பக்கத்திற்கு மாற்றப்படுவீர்கள். தொடர உங்கள் புதிய கடவுச்சொல்லைப் பயன்படுத்தி உள்நுழையவும்.",

  // USER PROFILE INFO
  firstName: "முதல் பெயர்",
  lastName: "கடைசி பெயர்",
  fullName: "முழுப்பெயர்",
  dateOfBirth: "பிறந்த தேதி",
  age: "வயது",
  gender: "பாலினம்",
  email: "மின்னஞ்சல் முகவரி",
  phone: "தொலைபேசி எண்",
  bio: "சுருக்கவிவரம்",
  religion: "மதம்",
  visitFrequency: "வருகை அடிக்கடி",
  maritalStatus: "திருமண நிலை",
  aadhaarNumber: "ஆதார் எண்",
  passportNumber: "கடவுச்சீட்டு எண்",
  occupation: "வேலை/தொழில்",
  bloodGroup: "இரத்த வகை",

  // EMPTY LABELS
  noGuidelines: "வழிகாட்டி தரவு இல்லை.",
  noDressCode: "உடை விதிமுறை தரவு இல்லை.",
  noAtonementRituals: "இந்த கோவிலில் பிராயச்சித்த சடங்குகள் இல்லை.",
  noTransport: "அருகிலுள்ள போக்குவரத்து வசதிகள் இல்லை.",
  noReviews: "உங்கள் கோவில் அனுபவத்தை பகிரும் முதலாளியாக இருங்கள்.",
  noFestivalEvents: "திருவிழா அல்லது நிகழ்ச்சி தரவு கிடைக்கவில்லை",
  noPoojaData: "பூஜை தொடர்பான தரவு கிடைக்கவில்லை",
  noOwnershipData: "உரிமையாளர் தரவு கிடைக்கவில்லை",
  noContactData: "தொடர்பு தரவு கிடைக்கவில்லை",
  noTempleImages: "கோவிலின் படங்கள் எதுவும் கிடைக்கவில்லை.",

  // COMMON LABELS
  shareTemple: "இந்த கோவிலை பகிரவும்",
  copied: "நகலெடுக்கப்பட்டது!",
};

export default ta;
